import * as React from 'react';
import ChangePasswordComponent, { ChangePasswordComponentProps } from './ChangePassword.component';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { changePassword, ChangePasswordAction } from 'src/actions/user/changePassword/ChangePassword.actions';
import * as changePasswordTypes from 'src/actions/user/changePassword/Types';
import { Action } from 'redux';
import { Data } from 'src/services/api-client/resource/base/Resource';
import ApiClient from 'src/services/api-client/ApiClient';

interface StateProps {
  error: boolean;
  errorMessage: {};
  loggedUserData: number | null;
}

interface DispatchProps {
  changePassword: (userId: number, newState: Data) => Promise<ChangePasswordAction>;
}

interface Props extends StateProps, DispatchProps { }

interface State {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  checkNewPass: boolean;
  checkCurrentPass: boolean;
  success: boolean;
}

class ChangePasswordContainer extends React.Component<Props, State> {

  public state = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    checkNewPass: false,
    checkCurrentPass: false,
    success: false,
  };

  public render(): React.ReactNode {
    return <ChangePasswordComponent {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);

      if (((key === 'confirmNewPassword') && (this.state.newPassword === value)) ||
        ((key === 'newPassword') && (this.state.confirmNewPassword === value))) {
        this.setState({checkNewPass: true});
      } else {
        this.setState({checkNewPass: false});
      }
    };
  }

    private handleSubmit(): void {
        const userId = this.props.loggedUserData!;
        this.props.changePassword(userId, this.state).then((response: Action) => {
            if (response.type === changePasswordTypes.CHANGE_PASSWORD_SUCCESS) {
              this.setState({success: true});
            }
        });
    }

  private handleOnBlur(): void {
    const userId = this.props.loggedUserData!;
    const params = {currentPassword: this.state.currentPassword};
    ApiClient.checkUserPassword.get(userId, params)
      .then(()  => {
        this.setState({checkCurrentPass: true});
      }).catch(() => {
      this.setState({checkCurrentPass: false});
    });
  }

  private getComponentProps(): ChangePasswordComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      handleOnBlur: () => this.handleOnBlur(),
      error: this.props.error,
      errorMessage: this.props.errorMessage,
      checkNewPass: this.state.checkNewPass,
      checkCurrentPass: this.state.checkCurrentPass,
      success: this.state.success,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    changePassword: (userId: number, newState: Data): Promise<ChangePasswordAction> => {
      return dispatch(changePassword(userId, newState));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  error: state.changePassword.error,
  errorMessage: state.changePassword.errorMessage,
  loggedUserData: state.authentication.loggedUserData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer);


// WEBPACK FOOTER //
// ./src/modules/my-account/change-password/ChangePassword.container.tsx